import React, { useState } from "react";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import Config from "config";
import DeleteButton from "components/Common/DeleteButtonList";
function TableComponent({ title, data, header, itemsPerPage }) {
  const [currentPage, setCurrentPage] = useState(0);
  const backUrl = Config.backOffice.url;
  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };
  const api = Config.backOffice.apiName;

  const offset = currentPage * itemsPerPage;
  const paginatedData = data.slice(offset, offset + itemsPerPage);
  const style = { textAlign: "right" };
  return (
    <div className="table-responsive" style={{ fontFamily: "sans-serif" }}>
      <table className="table">
        <thead>
          <tr>
            {title?.can_edit == false &&
            title?.can_show == false &&
            title?.can_destroy == false ? (
              <th></th>
            ) : (
              <th style={{ cursor: "default" }} key="Action" className="text">
                Action
              </th>
            )}
            {header.map((column, index) => (
              <th key={index} style={{ whiteSpace: "nowrap" }}>
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {paginatedData.length > 0 ? (
            <>
              {paginatedData.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  <td>
                    <ul className="list-unstyled hstack gap-1 mb-0">
                      {title?.can_show ? (
                        <li
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="View"
                        >
                          <Link
                            className="btn btn-sm btn-soft-primary"
                            id="viewtooltip-2"
                            to={`${backUrl}/investisseurs/${row.id}`}
                          >
                            <i className="mdi mdi-eye-outline"></i>
                          </Link>
                        </li>
                      ) : null}
                      {row.can_edit ? (
                        <li title="Editer">
                          <Link
                            className="btn btn-sm btn-soft-info"
                            id="edittooltip-2"
                            to={`${backUrl}/investisseurs/${row.id}/edit`}
                          >
                            <i className="mdi mdi-pencil-outline"></i>
                          </Link>
                        </li>
                      ) : null}
                      {title?.can_destroy ? (
                        <li title="Supprimer">
                          <DeleteButton
                            url={`https://www.fluxod.com/${api}/investisseurs/${row.id}`}
                          />
                        </li>
                      ) : null}
                    </ul>
                  </td>
                  {row?.statut_investisseur_id == "Validé" ? (
                    <td>
                      <span
                        className="bg-success badge bg-secondary"
                        style={{ fontSize: "100%" }}
                      >
                        {row?.statut_investisseur_id}
                      </span>
                    </td>
                  ) : (
                    <td>
                      {" "}
                      <span
                        className="badge-soft-danger badge bg-secondary"
                        style={{ fontSize: "100%" }}
                      >
                        {row?.statut_investisseur_id}
                      </span>
                    </td>
                  )}

                  <td>{row?.type_personne_id}</td>
                  <td>{row?.nom_investisseur}</td>
                  {row?.compte_ouvert == "Oui" ? (
                    <td>
                      <span
                        className="bg-success badge bg-secondary"
                        style={{ fontSize: "100%" }}
                      >
                        {row?.compte_ouvert}
                      </span>
                    </td>
                  ) : (
                    <td>
                      {" "}
                      <span
                        className="badge-soft-danger badge bg-secondary"
                        style={{ fontSize: "100%" }}
                      >
                        {row?.compte_ouvert}
                      </span>
                    </td>
                  )}

                  <td>{row?.partenaire_id}</td>
                  <td>{row?.courrier}</td>
                  <td style={style}>{row?.commentaires}</td>
                  <td style={style}>{row?.cree_le}</td>
                  <td style={style}>{row?.derniere_souscription}</td>
                </tr>
              ))}
            </>
          ) : (
            <tr>
              <td colSpan={header.length} style={{ textAlign: "center" }}>
                Aucune donnée à afficher
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <ReactPaginate
        previousLabel={"<<"}
        breakLabel={"..."}
        nextLabel={">>"}
        pageCount={Math.ceil(data.length / itemsPerPage)}
        marginPagesDisplayed={2}
        pageRangeDisplayed={3}
        onPageChange={handlePageChange}
        containerClassName={"pagination justify-content-center"}
        pageClassName={"page-item"}
        pageLinkClassName={"page-link"}
        previousClassName={"page-item"}
        previousLinkClassName={"page-link"}
        nextClassName={"page-item"}
        nextLinkClassName={"page-link"}
        breakClassName={"page-item"}
        breakLinkClassName={"page-link"}
        activeClassName={"active"}
      />
    </div>
  );
}

export default TableComponent;
